import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response } from '@angular/http';

import  { Observable } from 'rxjs/Observable';

import { HttpClient } from './http-client.service';

import { ProjectPartner } from '../../entities/project-partner';

import { Settings } from '../../settings';

import { DateConverter } from '../../utility/date-converter';

import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

import { CachedCallService } from './cached-call.service';

@Injectable()
export class ProjectPartnerService {

  private static readonly projectPartnerBaseUrl:string = `${Settings.apiUrl}/v1/ProjectPartners`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  public projectPartners:ProjectPartner[] = [];

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getProjectPartners():Promise<ProjectPartner[]>{

    return this.cachedCallService.invokeSingleCall(
      () => {
        let oDataBuilder:ODataBuilder = new ODataBuilder(ProjectPartnerService.projectPartnerBaseUrl);

        //TODO:  Add sort order?
        // oDataBuilder
        //   .orderBy("SortOrder");

        let projectPartnerUrl:string = oDataBuilder.toString();

        return this.http.get(projectPartnerUrl)
                .toPromise()
                .then(response => {
                  this.projectPartners = response.json().value;

                  return this.projectPartners;
                });
      }, "getProjectPartners"
    );
    
  }
} 



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/project-partner.service.ts